/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOptionRespVo } from './GetOptionRespVo';
import {
    GetOptionRespVoFromJSON,
    GetOptionRespVoFromJSONTyped,
    GetOptionRespVoToJSON,
    GetOptionRespVoToJSONTyped,
} from './GetOptionRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetOptionRespVo
 */
export interface ResponseListGetOptionRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetOptionRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetOptionRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetOptionRespVo>}
     * @memberof ResponseListGetOptionRespVo
     */
    data?: Array<GetOptionRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetOptionRespVo interface.
 */
export function instanceOfResponseListGetOptionRespVo(value: object): value is ResponseListGetOptionRespVo {
    return true;
}

export function ResponseListGetOptionRespVoFromJSON(json: any): ResponseListGetOptionRespVo {
    return ResponseListGetOptionRespVoFromJSONTyped(json, false);
}

export function ResponseListGetOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetOptionRespVoFromJSON)),
    };
}

export function ResponseListGetOptionRespVoToJSON(json: any): ResponseListGetOptionRespVo {
    return ResponseListGetOptionRespVoToJSONTyped(json, false);
}

export function ResponseListGetOptionRespVoToJSONTyped(value?: ResponseListGetOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetOptionRespVoToJSON)),
    };
}

